import { AxiosInstance, AxiosPromise } from 'axios';

import { Axios } from '@/services/Axios';
import { SiteSurveyStep, SiteUpload } from '@/store/reducers/site-survey/types';
import { SiteSurveyType } from '@/types';

import { ProgressEventHandler, UploadFileSurvey } from './types';

export class SiteSurveyControllerClass {
  private APIService: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.APIService = instance;
  }

  public uploadFile = (
    activityId: string,
    upload: UploadFileSurvey,
    onProgress: ProgressEventHandler,
  ): AxiosPromise<SiteUpload> => {
    const formData = new FormData();
    const headers = {
      'Content-Type': 'multipart/form-data',
    };
    const url = 'activities/surveys';

    formData.append('ImageContent', upload.file);
    formData.append('activityId', activityId);
    formData.append('StepNumber', upload.stepNumber.toString());
    formData.append('Type', SiteSurveyType.Image.toString());

    return this.APIService.post<SiteUpload>(url, formData, {
      headers,
      cancelToken: upload.token,
      onUploadProgress: onProgress,
    });
  };

  public loadSurvey = (activityId: string): AxiosPromise<SiteSurveyStep[]> => {
    const url = `activities/${activityId}/surveys`;

    return this.APIService.get<SiteSurveyStep[]>(url);
  };

  public saveAdditionaSurveylTask = (
    activityId: string,
    stepPayload: SiteSurveyStep,
  ): AxiosPromise<SiteUpload> => {
    const formData = new FormData();
    const headers = {
      'Content-Type': 'multipart/form-data',
    };
    const url = 'activities/surveys';
    const stepNumber = stepPayload.stepNumber || '';
    const mainServiceDisconnectSize = stepPayload.mainServiceDisconnectSize || '';
    const atticAccessInformation = stepPayload.atticAccessInformation || '';
    const atticPhotos = stepPayload.atticPhotos || '';
    const comments = stepPayload.comments ?? '';

    const SkipSheathing = stepPayload.skipSheathing ?? '';
    const RadiantBarrier = stepPayload.radiantBarrier ?? '';
    const SprayFoam = stepPayload.sprayFoam ?? '';
    const roofDeckingVerification = stepPayload.roofDeckingVerification ?? '';

    switch (stepPayload.type) {
      case SiteSurveyType['Main Service Disconnect Size']:
        formData.append('MainServiceDisconnectSize', mainServiceDisconnectSize.toString());
        break;
      case SiteSurveyType['Attic Access Information']:
        formData.append('AtticAccessInformation', atticAccessInformation.toString());
        break;
      case SiteSurveyType['Attic Photos']:
        formData.append('AtticPhotos', atticPhotos.toString());
        break;
      case SiteSurveyType.Comment:
        formData.append('Comments', comments.toString());
        break;
      case SiteSurveyType['Decking Details']:
        formData.append('skipSheathing', SkipSheathing.toString());
        formData.append('radiantBarrier', RadiantBarrier.toString());
        formData.append('sprayFoam', SprayFoam.toString());
        break;
      case SiteSurveyType['Decking Verification']:
        formData.append('RoofDeckingVerification', roofDeckingVerification.toString());
        break;
      default:
        break;
    }

    formData.append('Type', stepPayload.type.toString());
    formData.append('activityId', activityId);
    formData.append('StepNumber', stepNumber.toString());

    return this.APIService.postForm(url, formData, {
      headers,
    });
  };
}

export const SiteSurveyController = new SiteSurveyControllerClass(Axios);
